import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormOtherDocumentTemplate from './form-other-document-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateOtherDocumentItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function EditOtherDocumentTemplate({ dismiss, item, form }) {
  const handleMutationCompletion = (response) => {
    if (response.updateOtherDocumentItemTemplate.errors) {
      addErrorsToForm(form, response.updateOtherDocumentItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateOtherDocument] = useMutation(UpdateOtherDocumentItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    updateOtherDocument({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
  };

  return (
    <FormOtherDocumentTemplate
      initialValues={initialValues}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      showExpiration
      form={form}
    />
  );
}

EditOtherDocumentTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
